import { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useUnit } from 'effector-react';
import { $user, setUser } from 'models/user';
import { normalizeKeycloakUser } from '@/utils/user';

const useUserProfile = () => {
  const { keycloak } = useKeycloak();
  const user = useUnit($user);

  useEffect(() => {
    if (keycloak.authenticated && !user && keycloak.tokenParsed) {
      setUser(normalizeKeycloakUser(keycloak.tokenParsed));
    }
  }, [keycloak.authenticated, keycloak.token, keycloak.tokenParsed, user]);

  return { user, keycloak, isLoading: Boolean(keycloak.authenticated && !user) };
};

export default useUserProfile;
